import React from 'react';
import LocationMap from './location_map';
import 'leaflet/dist/leaflet.css';

const GeolocationModal = ({ isOpen, onClose, locations, radius }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-3/4 max-w-lg relative">
        <button
          className="absolute top-2 right-4 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          &#x2715;
        </button>
        <h2 className="text-lg font-bold mb-4">Area registrazione timbratura</h2>
        {locations?.length > 0 ? (
          <div style={{ height: '60vh', width: '100%' }}>
            <LocationMap locations={locations} radius={radius} />
          </div>
        ) : (
          <div className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-gray-600 font-normal text-md">
            Posizione non registrata
          </div>
        )}
      </div>
    </div>
  );
};

export default GeolocationModal;
